import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppConfig } from './useAppConfig';

export const useDocumentTitle = () => {
  const location = useLocation();
  const { config, pages } = useAppConfig();

  useEffect(() => {
    if (!config) return;

    // Get the current route path
    const path = location.pathname;
    
    // Extract route from path (e.g., "/home" -> "home", "/sa" -> "sa", "/repairs" -> "repairs")
    const route = path === '/' ? 'home' : path.slice(1);
    
    // Get the page name from app config
    const pageConfig = pages?.[route as keyof typeof pages];
    const pageName = pageConfig?.name;
    
    // Get the app name from metadata
    const appName = config.metadata?.name;
    
    // Construct the title
    let title = '';
    if (pageName && appName) {
      title = `${pageName} | ${appName}`;
    } else if (pageName) {
      title = pageName;
    } else if (appName) {
      title = appName;
    } else {
      title = 'Parts Counter Assistant'; // fallback
    }
    
    // Update the document title
    document.title = title;
    
    // Also update meta tags for better SEO
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', pageConfig?.subTitle || 'AI-powered parts counter assistant');
    }
    
    // Update Open Graph title
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', title);
    }
    
    // Update Open Graph description
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', pageConfig?.subTitle || 'AI-powered parts counter assistant');
    }
    
  }, [location.pathname, config, pages]);
}; 